import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    FetchData, Helpers,

    defaultData,

    //------------- Forms
    Forms,

    globalStates

}) => {

    const { convertToFloat } = Helpers

    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });

    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }

    const closeModal = () => {
        toggle()
    }

    const handleClickShowForm = (openingMode) => {
        const { setShowForm, setFormOpeningMode } = globalStates
        setFormOpeningMode(openingMode)
        setShowForm(true)
    }

    const handleClickShowLogBook = (idcredito) => {
        const { setShowLogBook} = globalStates
        const { FormRequestGlobal: {setFormState} } = Forms

        const {fetchInfoLogBook:{executeFetchInfoLogBook}} = FetchData

        setFormState(prevState => ({
            ...prevState,
            idcredito: idcredito
        }))

        setShowLogBook(true)
        executeFetchInfoLogBook()
    }

    const handleClickHideForm = () => {

        const { setShowForm, setStepApplilication } = globalStates

        const { fetchAllCreditsApplication: { executeFetchAllCreditsApplications } } = FetchData

        const { FormRequestGlobal: { onResetForm } } = Forms

        onResetForm()
        executeFetchAllCreditsApplications()

        setStepApplilication(0)
        setShowForm(false)
    }

    const handleClickReturnStep = () => {
        const { stepApplilication, setStepApplilication } = globalStates
        setStepApplilication(stepApplilication - 1)
    }

    const handleClickNextStep = () => {
        const { stepApplilication, setStepApplilication } = globalStates
        setStepApplilication(stepApplilication + 1)
    }



    const handleClickCleanUpFiles = (event) => {
        const { FormRequestGlobal: { setFormState } } = Forms

        // const { fetchAllDeposits } = FetchData
        // const { executeFetchAllDeposits } = fetchAllDeposits

        setFormState(prevState => ({
            ...prevState,
            fileRejections: [],
            acceptedFiles: []
        }))

        // executeFetchAllDeposits()

    }

    //     const handleClickDeleteDocument = (iddocumento) => {

    //         const { fetchAllFiles } = FetchData
    //         const { executeFetchAllFiles } = fetchAllFiles
    //         Swal.fire({
    //             title: '¿Desea eliminar este registro?',
    //             showConfirmButton: true,
    //             showCancelButton: true,
    //             confirmButtonText: 'Eliminar',
    //             cancelButtonText: 'Cancelar'
    //         }).then(async result => {
    //             if (result.isConfirmed) {
    //                 await marvarApi.delete(`/leases/common/delete-document/${iddocumento}`)
    //                 .then( ({ data }) => {
    //                     alertMessage(data)
    //                     if (data.title === 'OK') {
    //                         executeFetchAllFiles()
    //                         // closeModal()
    //                         }else{

    //                         }
    //                 }).catch(error => {
    //                     console.log('API ERROR: ', error)
    //                 })
    //             }
    //         })
    //     }

    //     const handleClickDeleteDeposit = (iddocumento) => {

    //         const { fetchAllDeposits } = FetchData
    //         const { executeFetchAllDeposits } = fetchAllDeposits
    //         Swal.fire({
    //             title: '¿Desea eliminar este registro?',
    //             showConfirmButton: true,
    //             showCancelButton: true,
    //             confirmButtonText: 'Eliminar',
    //             cancelButtonText: 'Cancelar'
    //         }).then(async result => {
    //             if (result.isConfirmed) {
    //                 await marvarApi.delete(`/leases/management/delete-deposit/${iddocumento}`)
    //                 .then( ({ data }) => {
    //                     alertMessage(data)
    //                     if (data.title === 'OK') {
    //                         executeFetchAllDeposits()
    //                         // closeModal()
    //                         }else{

    //                         }
    //                 }).catch(error => {
    //                     console.log('API ERROR: ', error)
    //                 })
    //             }
    //         })
    //     }

    //     const handleChangeTotalMonths = ({ target }) => {
    //         // console.log(event);
    //         const { FormLeases } = Forms
    //         const { formState ,setFormState } = FormLeases

    //         // const data = JSON.parse(event.target.value || null)

    //         const { name, value } = target;
    //         setFormState({
    //             ...formState,
    //             [ name ]: value,
    //             contrato_total_alquiler: (formState.contrato_costo_alquiler * (value || 0))
    //         });
    //     }

    const handleChangeTypeCurrency = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState } = FormDeposit
        const { clean_deposito_monto, deposito_tipo_cambio } = formState

        const { name, value } = event.target

        //Verificamos si tiene data
        const tipo_cambio = deposito_tipo_cambio !== '' ? deposito_tipo_cambio : 0;


        if (value === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_deposito_monto),
                clean_deposito_quetzales: (clean_deposito_monto * tipo_cambio),
                clean_deposito_dolares: clean_deposito_monto
            }))
        } else if (value === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto),
                deposito_dolares: numberFormatter.format(clean_deposito_monto / tipo_cambio),
                clean_deposito_quetzales: clean_deposito_monto,
                clean_deposito_dolares: (clean_deposito_monto / tipo_cambio)
            }))
        }
    }


    const onSubmitFormApplies = async (e) => {

        e.preventDefault()

        handleClickNextStep()

    }

    const onSendLogs = async (e) => {


        const { FormRequestGlobal } = Forms
        const { formState, setFormState } = FormRequestGlobal

        const { fetchInfoObservations: { executeFetchAllObservations } } = FetchData


        const { getCurrentDate } = Helpers

        await marvarApi.post(`/credits/common/log-vehicle/${formState.idcredito}`, {
            idusuario: user.uid,
            log_fecha: getCurrentDate(),
            log_observacion: formState.aprobacion_observaciones,
            log_departamento: "Gestor"
        })
            .then(({ data }) => {
                alertMessage(data)
                if (data.title === 'OK') {
                    setFormState((prevState) => ({
                        ...prevState,
                        aprobacion_observaciones: ''
                    }))
                    executeFetchAllObservations()
                }
            })

    }

    const onSubmitFormFiles = async (e) => {

        e.preventDefault()

        const { FormRequestGlobal: { formState, setFormState } } = Forms
        const { getCurrentDate } = Helpers


        const { fetchAllFiles: { executeFetchAllFiles }, fetchInfoApplication: { executeFetchInfoApplication } } = FetchData



        if (formState.acceptedFiles.length <= 0) {
            const messageCustom = {
                message: 'No se ha cargado nigun archivo',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        const _data = new FormData();

        _data.append('idcredito', formState.idcredito);
        _data.append('department', 'ADMINISTRADOR');
        _data.append('usuario_creo', user.username);
        _data.append('fecha_creo', getCurrentDate());


        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`attachmentt`, file);
        });

        if (formState.idcredito > 0) {

            await marvarApi.post(`/credits/common/create-document`, _data)
                .then(async ({ data }) => {

                    if (data.title === 'OK') {
                        setFormState(prevState => ({
                            ...prevState,
                            acceptedFiles: [],
                            fileRejections: []
                        }))
                        executeFetchAllFiles()
                    }
                    alertMessage(data)
                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    }

    const handleClickDeleteDocument = (iddocumento) => {

        const { fetchAllFiles } = FetchData
        const { executeFetchAllFiles } = fetchAllFiles
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/credits/common/delete-document/${iddocumento}`)
                    .then(({ data }) => {
                        alertMessage(data)
                        if (data.title === 'OK') {
                            executeFetchAllFiles()
                            // closeModal()
                        } else {

                        }
                    }).catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }


    const handleClickShowModal = (_, title, compont, dataRequest, modalOpeningMode) => {
        const { setModalOpeningMode } = globalStates
        setModalOpeningMode(modalOpeningMode)
        openModal(_, title, compont, dataRequest)
    }

    const handleClickCloseModal = () => {

        //HOOKS
        const { FormDeposit, FormCollateral } = Forms
        const { onResetForm } = FormDeposit
        const onResetFormCollateral = FormCollateral.onResetForm
        onResetForm()
        onResetFormCollateral()
        closeModal()
    }

    const onSubmitFormDeposits = async (e) => {

        e.preventDefault()

        const { FormDeposit, FormRequestGlobal } = Forms
        const { formState, onResetForm } = FormDeposit
        const formStateGlobal = FormRequestGlobal.formState

        const { fetchAllDeposits: { executeFetchAllDeposits } } = FetchData

        const { getCurrentDate } = Helpers



        const _data = {
            aprobacion_check: formState.aprobacion_check,
            aprobacion_referencia_ach: formState.aprobacion_referencia_ach,
            aprobacion_observaciones: formState.aprobacion_observaciones,
            aprobacion_usuario: user.username,
            aprobacion_fecha: getCurrentDate()
        }

        await marvarApi.put(`/credits/admin-managements/aprobacion-check-deposit/${formState.iddeposit}`, _data)
            .then(({ data }) => {

                alertMessage(data)

                if (data.title === 'OK') {
                    onResetForm()
                    executeFetchAllDeposits()
                    closeModal()
                }

            })
            .catch(error => {
                console.log('API ERROR: ', error)
            })

    }

    const handleChangeAmount = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState, onInputChangeForNumber } = FormDeposit
        const { deposito_tipo_cambio } = formState

        const { value } = event.target

        onInputChangeForNumber(event)
        const clean_value = convertToFloat(value)

        //Verificamos si tiene data
        const tipo_cambio = deposito_tipo_cambio !== '' ? parseFloat(deposito_tipo_cambio) : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                deposito_quetzales: numberFormatter.format(clean_value * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_value),
                clean_deposito_quetzales: (clean_value * tipo_cambio),
                clean_deposito_dolares: clean_value
            }))
        } else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                deposito_quetzales: numberFormatter.format(clean_value),
                deposito_dolares: numberFormatter.format(clean_value / tipo_cambio),
                clean_deposito_quetzales: clean_value,
                clean_deposito_dolares: (clean_value / tipo_cambio)
            }))
        }
    }

    const handleChangeExchangeRate = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState } = FormDeposit
        const { clean_deposito_monto } = formState

        const { name, value } = event.target

        //Verificamos si tiene data
        // const monto = deposito_monto !== '' ? deposito_monto : 0;
        const tipo_cambio = value !== '' ? parseFloat(value) : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_deposito_monto),
                clean_deposito_quetzales: (clean_deposito_monto * tipo_cambio),
                clean_deposito_dolares: clean_deposito_monto
            }))
        } else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto),
                deposito_dolares: (tipo_cambio === 0) ? 0 : numberFormatter.format(clean_deposito_monto / tipo_cambio),
                clean_deposito_quetzales: clean_deposito_monto,
                clean_deposito_dolares: (tipo_cambio === 0) ? 0 : (clean_deposito_monto / tipo_cambio)
            }))
        } else {
            setFormState(prevState => ({
                ...prevState,
                [name]: value
            }))
        }
    }

    const handleClickFetchInfoDeposit = async (iddeposit) => {

        const { FormDeposit: { onResetForm } } = Forms


        const { fetchInfoDeposit } = FetchData
        const { setParamsToSearch, executeFetchInfoDeposit } = fetchInfoDeposit

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({ iddeposit: iddeposit })
        executeFetchInfoDeposit()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowModal('', 'Formulario de depositos', 'deposits-section', {}, 'READONLY')

    }

    const handleClickDownloadImage = async (customFileName, openUrl) => {

        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();

            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);

            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();

            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);

            toast.success('Se ha descargado la imagen');

        } catch (error) {
            console.error('Error al descargar la imagen', error);
        }

    }

    const handleClickDeleteDeposit = (iddeposit) => {

        const { fetchAllDeposits } = FetchData
        const { executeFetchAllDeposits } = fetchAllDeposits
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/credits/common/delete-deposit/${iddeposit}`)
                    .then(({ data }) => {
                        alertMessage(data)
                        if (data.title === 'OK') {
                            executeFetchAllDeposits()
                        } else {

                        }
                    }).catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }

    const onSubmitFormCollateral = async (e) => {

        e.preventDefault()

        const { getCurrentDate } = Helpers

        //HOOKS
        const { FormCollateral: { formState }, FormRequestGlobal } = Forms
        const formStateGlobal = FormRequestGlobal.formState

        const { modalOpeningMode } = globalStates

        const { fetchAllCollateral: { executeFetchCollateral } } = FetchData

        //Validaciones generales
        if (formState.type_collateral === '') {
            const messageCustom = {
                message: 'Debe seleccionar un tipo de garantia',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        let _data = {
            idcredito: formStateGlobal.idcredito,
            title: formState.title,
            type_collateral: formState.type_collateral,
            estate: formState.estate,
            folio: formState.folio,
            department: formState.department,
            book: formState.book,
            description: formState.description,
            valor: formState.clean_valor,
            marca: formState.marca,
            modelo: formState.modelo,
            linea: formState.linea,
            color: formState.color,
            matricula: formState.matricula,
            chasis: formState.chasis,
        }


        if (formState.idcollateral > 0) {

            if (modalOpeningMode === 'EDITABLE') {

                _data['usuario_modifico'] = user.username;
                _data['fecha_modifico'] = getCurrentDate();

                await marvarApi.put(`/credits/mgmt-managements/collateral/${formState.idcollateral}`, _data)
                    .then(({ data }) => {

                        alertMessage(data)

                        if (data.title === 'OK') {
                            executeFetchCollateral()
                            handleClickCloseModal()
                        }

                    }).catch(error => { console.log('API ERROR: ', error) })
            } else {
                handleClickCloseModal()
            }

        } else {

            _data['usuario_creo'] = user.username;
            _data['fecha_creo'] = getCurrentDate();

            await marvarApi.post(`/credits/mgmt-managements/collateral`, _data)
                .then(({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        executeFetchCollateral()
                        handleClickCloseModal()
                    }

                }).catch(error => { console.log('API ERROR: ', error) })
        }

    }


    const handleClickFetchInfoCollateral = async (idcollateral, modeOpening) => {

        const { FormCollateral: { onResetForm, setFormState } } = Forms

        const { fetchInfoCollateral: { setParamsToSearch, executeFetchCollateral } } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({ idcollateral: idcollateral })
        executeFetchCollateral()

        setFormState(prevState => ({
            ...prevState,
            idcollateral: idcollateral
        }))


        handleClickShowModal('', 'Formulario de Garantias', 'collateral-section', {}, modeOpening)

    }

    const handleClickDeleteCollateral = (idcollateral) => {

        const { fetchAllCollateral: { executeFetchCollateral } } = FetchData
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/credits/mgmt-managements/delete-collateral/${idcollateral}`)
                    .then(({ data }) => {
                        alertMessage(data)
                        if (data.title === 'OK') {
                            executeFetchCollateral()
                        } else {

                        }
                    }).catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }

    const handleClickFetchInfoApplication = async (idcredito, idcotizacion, modeOpening) => {

        const { FormRequestGlobal: { onResetForm, setFormState } } = Forms

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setFormState(prevState => ({
            ...prevState,
            idcredito: idcredito,
            idcotizacion: idcotizacion,
        }))
        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowForm(modeOpening)

    }

    const handleClickDeleteApplication = (idcredito) => {

        const { fetchAllCreditsApplication: { executeFetchAllCreditsApplications } } = FetchData
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar',
            text: 'Esta acción eliminara toda la informacion relacionada con esta solicitud. Esta accion no se puede deshacer'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/credits/mgmt-managements/${idcredito}`)
                    .then(({ data }) => {
                        alertMessage(data)
                        if (data.title === 'OK') {
                            executeFetchAllCreditsApplications()
                        }
                    }).catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }

    const handleClickApproval = async () => {
        //HOOKS
        const { FormRequestGlobal } = Forms
        const { formState, setFormState } = FormRequestGlobal
        const { getCurrentDate } = Helpers


        if (formState.aprobacion_check === 'Devuelto a Gestor') {
            await marvarApi.put(`/vehicle/legal/aprobacion-check/${formState.idcredito}`, { aprobacion_check: 'Devuelto a Juridico', aprobacion_usuario: user.username, aprobacion_fecha: getCurrentDate() })
                .then(({ data }) => {
                    alertMessage(data)
                    handleClickHideForm()
                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
        } else {
            handleClickHideForm()
        }
    }

    const handleClickUpdateAprobacion = async () => {

        const {getCurrentDate} = Helpers

        const { FormRequestGlobal:{ formState } } = Forms

        const { fetchAllCreditsApplication :{executeFetchAllCreditsApplications}} = FetchData

        const body = {
            idcotizacion: formState.idcotizacion, 
            aprobacion_check: formState.aprobacion_check, 
            aprobacion_usuario: user.username, 
            aprobacion_fecha: getCurrentDate()
        }

        await marvarApi.put(`/credits/admin-managements/aprobacion-check/${formState.idcredito}`, body).then(({ data }) => {
            alertMessage(data)
            if (data.title === 'OK') {
                executeFetchAllCreditsApplications()
                handleClickHideForm()
            }
        })
        .catch(error => {
            console.log('API ERROR: ', error)
        })
    }


    const handleClickCloseLogs = () => {

        const {setShowLogBook} = globalStates

        const {FormLogBook:{onResetForm}} = Forms
        
        onResetForm()

        setShowLogBook(false)
    
    }


    const handleClickCloseExpenses = () => {

        const {setShowExpenses} = globalStates

        const {FormExpenses:{onResetForm}} = Forms
        
        onResetForm()

        setShowExpenses(false)
    
    }

    const onSendLog = async () => {
        const { FormLogBook:{formState, onResetForm}, FormRequestGlobal } = Forms
        const formStateGlobal = FormRequestGlobal.formState

        const {fetchInfoLogBook:{executeFetchInfoLogBook}} = FetchData

        const {getCurrentDate} = Helpers

        const _data = new FormData();

        _data.append('idcredito', formStateGlobal.idcredito);
        _data.append('idusuario', user.uid);
        _data.append('fecha_bitacora', getCurrentDate());
        _data.append('descripcion', formState.descripcion);
        _data.append('vigencia_credito', "COBRO EXTRAJUDICIAL"); // TODO: Actualizar estado


        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`attachmentt`, file);
        });

        if(formStateGlobal.idcredito>0){
            
            await marvarApi.post( `/credits/legal-credits/create-log-entry`, _data )
                .then(async ({ data }) => {
                    
                    alertMessage(data)

                    if (data.title === 'OK') {
                        onResetForm()
                        executeFetchInfoLogBook()
                    }
                    })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
                    
        }

    }

    const handleClickShowExpenses = (idcredito) => {
        const { setShowExpenses} = globalStates
        const { FormRequestGlobal: {setFormState} } = Forms

        const {fetchAllLegalExpenses:{executeFetchAllLegalExpenses}} = FetchData

        setFormState(prevState => ({
            ...prevState,
            idcredito: idcredito
        }))

        setShowExpenses(true)
        executeFetchAllLegalExpenses()
    }

    const handleClickFetchInfoExpenses = async () => {


        handleClickShowModal('', 'Formulario de gastos', 'expenses-section', {}, 'EDITABLE')

    }

        const onSubmitFormExpenses = async (e) => {
    
            e.preventDefault()
        
            const { FormExpenses: { formState, onResetForm, setFormState }, FormRequestGlobal } = Forms
            const formStateGlobal = FormRequestGlobal.formState
    
            const {getCurrentDate} = Helpers
        
            const {fetchAllLegalExpenses:{executeFetchAllLegalExpenses}} = FetchData
    
            if(formStateGlobal.idcredito>0){
    
                const body = {
                    idusuario: user.uid,
                    gasto_fecha: formState.gasto_fecha,
                    gasto_descripcion: formState.gasto_descripcion,
                    usuario_creo: user.username,
                    fecha_creo: getCurrentDate(),
                    gasto_monto: formState.clean_gasto_monto
                }
    
                await marvarApi.post( `/credits/common/create-expense/${formStateGlobal.idcredito}`, body )
                .then(({ data }) => {
        
                    alertMessage(data)
        
                    if (data.title === 'OK') {
                        onResetForm()
                        executeFetchAllLegalExpenses()
                        closeModal()
                    }
                    
                })
                .catch(error => {
                        console.log('API ERROR: ', error)
                })
            }
        }
    
        const handleButtonDeleteExpenses = (idgasto) => {
    
            const {fetchAllLegalExpenses:{executeFetchAllLegalExpenses}} = FetchData
    
            Swal.fire({
                title: '¿Desea eliminar este registro?',
                text: 'Esta acción elimara el gasto asociado al credito de vehiculo',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#ff6219',
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Cancelar'
            }).then(async result => {
                if (result.isConfirmed) {
                    await marvarApi.delete(`/credits/legal-credits/delete-expense/${idgasto}`)
                    .then( async ({ data }) => {
                        alertMessage(data)
                        executeFetchAllLegalExpenses()
                    }).catch(error => {
                        console.log('API ERROR: ', error)
                    })
                }
            })
        }

    return Object.freeze({
        handleClickShowForm,
        handleClickHideForm,
        onSubmitFormApplies,
        onSendLogs,
        handleClickCleanUpFiles,
        handleClickReturnStep,
        handleClickNextStep,
        onSubmitFormFiles,
        handleClickDeleteDocument,
        handleClickShowModal,
        handleClickCloseModal,
        onSubmitFormDeposits,
        handleChangeTypeCurrency,
        handleChangeAmount,
        handleChangeExchangeRate,
        handleClickFetchInfoDeposit,
        handleClickDownloadImage,
        handleClickDeleteDeposit,
        onSubmitFormCollateral,
        handleClickFetchInfoCollateral,
        handleClickDeleteCollateral,
        handleClickFetchInfoApplication,
        handleClickDeleteApplication,
        handleClickApproval,
        handleClickUpdateAprobacion,
        handleClickShowLogBook,
        handleClickCloseLogs,
        handleClickCloseExpenses,
        onSendLog,
        handleClickShowExpenses,
        handleClickFetchInfoExpenses,
        onSubmitFormExpenses,
        handleButtonDeleteExpenses,
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message } = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}